import Link from 'next/link'
import styled from 'styled-components'

import Icon from '@totallymoney/ui/icons/Icon'
import anchorStyles from '@totallymoney/ui/styles/anchor'
import { focusStylesWithRoundedEdges } from '@totallymoney/ui/styles/focus'
import theme from '@totallymoney/ui/theme'

export const StyledNextLink = styled(Link)`
    display: inline-flex;
    align-items: center;

    ${anchorStyles};
    ${focusStylesWithRoundedEdges};
`

export const StyledIcon = styled(Icon)`
    margin-left: ${theme.space10};

    &:hover {
        color: ${theme.indigo80};
    }
`
